import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 50
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-cf-red text-white text-center py-[3px] px-3 font-bold text-[11px] md:text-xs sticky top-0 z-50" data-id="element-1">
      <div className="flex items-center justify-center gap-1.5" data-id="element-2">
        <span data-id="element-3">⏳ OFERTA EXPIRA EN:</span>
        <span className="bg-white/20 text-white px-1.5 py-[1px] rounded font-mono text-[11px] md:text-xs" data-id="element-4">
          {String(timeLeft.minutes).padStart(2, '0')}:
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
        <span className="hidden sm:inline" data-id="element-5">|</span>
        <span className="hidden sm:inline" data-id="element-6">🔥 SOLO QUEDAN 3 CUPOS</span>
      </div>
    </div>;
}